import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LikesService } from 'src/app/shared/likes.service';
import * as WaveSurfer from 'wavesurfer.js';
import { DashboardService } from '../my-dashboard.service';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-pip',
  templateUrl: './custom-pip.component.html',
  styleUrls: ['./custom-pip.component.scss']
})
export class CustomPipComponent implements OnInit {
	@ViewChild('waveform') private waveformElement?: ElementRef<HTMLDivElement>;
	wavesurfer?: WaveSurfer.default;
	audioUrls: string[] = [
		// '../../../../../assets/sample-3s.mp3'
		"../../../../../../assets/orchestrawav-26158.mp3"
	];
	// urlIndex: number = 0;
	isPlaying: boolean = false;
	currentTime: any = 0;
	durationTime: number = 0;
	skipForward:any = 0;
	skipBackward:any = 0;
	prgNameHeight:number=0;
	selectedPodcast: any;
	userId: string = "";
	userData: any;
	currentUrl:string='/my-dashboard';
	isMuted:boolean=false;
	isLiked:boolean=false;
	selectedPodcastSeason: any;
	selectedPodcastEpisode: any;
	likesIdData: any;
	likeDocId: any;
	isiPhone:boolean=false;
	isLoadingWavesurfer: boolean = false;

	constructor(
		private snackbar: MatSnackBar,
		private likesService: LikesService,
		private dashboardService: DashboardService,
		private router: Router,
		private deviceDetectorService: DeviceDetectorService
	) {
		this.router.events
		.pipe(filter(event => event instanceof NavigationEnd))
		.subscribe((event: any) => {
		  this.currentUrl = event.url;
		});
	}

	async ngOnInit() {
		this.userId = localStorage.getItem("userId") ?? "";
		this.userData = await this.dashboardService.getUserData();

		this.isiPhone = this.deviceDetectorService.isMobile() && this.deviceDetectorService.device === 'iPhone';
		// console.log('isiPhone', this.isiPhone)
	}

	async ngAfterViewInit() {
		this.selectedPodcast = this.likesService.selectedPodcastValue.getValue();
		this.likesIdData = await this.likesService.getUserLikes(this.userId);

		if (this.selectedPodcast) {
			// this.likesService.selectedPodcastValue.next(this.selectedPodcast);
			this.selectedPodcastSeason = this.selectedPodcast.season_number;
			this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
			let likeDocId;
			const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
				let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
				likeDocId = likeData.id;
				return likeData.entityId === entityId;
			});

			if (getEpisodeLike === -1) {
				this.isLiked = false;
				this.likeDocId = "";
			} else {
				this.isLiked = true;
				this.likeDocId = likeDocId;
			}
		}

		if (this.waveformElement) {
			this.wavesurfer = WaveSurfer.default.create({
				container: this.waveformElement.nativeElement,
				height: 20,
				barWidth: 3,
				barGap: 3,
				waveColor: '#fff',
				progressColor: '#7881E6',
				fetchParams: {
					mode: "no-cors",
				}
			});

			let playingState: any = localStorage.getItem('playingState');
			// console.log(playingState);
			if (playingState === "true") {
				playingState = true;
			} else {
				playingState = false;
			}

			// console.log(this.selectedPodcast);
			try {
				this.isLoadingWavesurfer = true;
				await this.wavesurfer.load(this.audioUrls[0]);
				await this.wavesurfer.load(this.selectedPodcast.audio_url);
			} catch (err) {
				console.log("Error in initial loading of podcast audio.");
			} finally {
				this.isLoadingWavesurfer = false;
			}

			this.durationTime = this.selectedPodcast.duration;

			this.wavesurfer?.on('play', async () => {
				this.isPlaying = true;
				// console.log("played pip audio!");
				await this.watchPlayEvent();
			});
			this.wavesurfer?.on('pause', () => {
				this.isPlaying = false;
				// console.log("Paused pip audio!");
			});
			this.wavesurfer?.on('audioprocess', () => this.currentTime = this.wavesurfer?.getCurrentTime());
			this.wavesurfer?.on('seeking', () => {
				this.currentTime = this.wavesurfer!.getCurrentTime();
			});

			this.wavesurfer?.on('audioprocess', () => {
				const currentTime = this.wavesurfer?.getCurrentTime();
				if (currentTime !== undefined) {
					// console.log('custom pip currentTime', currentTime)
					this.likesService.currentTimeValue.next(currentTime);
				}
			});

			// console.log(this.likesService.playValueSubject.getValue());
			if (this.likesService.playValueSubject.getValue() || playingState) {
				this.wavesurfer.play();
			}
			this.currentTime = this.likesService.currentTimeValue.getValue();
			if (this.currentTime) {
				this.wavesurfer.setTime(this.currentTime)
			}
		}
	}

	async watchPlayEvent() {
		if (this.isPlaying) {
			let currentTime: any = this.wavesurfer?.getCurrentTime();
			if (currentTime) {
				currentTime = Math.ceil(currentTime);
				if (currentTime > this.selectedPodcast.duration || this.selectedPodcast.duration - currentTime <= 2) {
					currentTime = this.selectedPodcast.duration;
				}
				let progress = Math.ceil((currentTime * 100) / this.selectedPodcast.duration);
				if (progress >= 99 || isNaN(progress)) {
					progress = 100;
					currentTime = this.selectedPodcast.duration;
				}

				let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
				let podcastsProgress = this.userData.podcastsProgress;

				let newProgressObj: any = {
					watchedDuration: currentTime,
					totalDuration: this.selectedPodcast.duration,
					entityId,
					progress
				};

				if (progress === 100) {
					newProgressObj.completedAt = new Date();
				}
				if (this.userData && podcastsProgress && podcastsProgress.length >= 1) {
					let hasProgressIndex = podcastsProgress.findIndex((item: any) => item.entityId === entityId);
					if (hasProgressIndex === -1) {
						podcastsProgress.push(newProgressObj);
						await this.dashboardService.updateUserData(this.userId, {
							podcastsProgress
						});
					} else {
						let item = podcastsProgress[hasProgressIndex];

						if (item.progress !== 100) {
							podcastsProgress[hasProgressIndex] = newProgressObj;

							await this.dashboardService.updateUserData(this.userId, {
								podcastsProgress
							});
						}
					}
				} else {
					podcastsProgress = [newProgressObj];
					this.userData.podcastsProgress = podcastsProgress;
					await this.dashboardService.updateUserData(this.userId, {
						podcastsProgress
					});
				}
			}

			setTimeout(async () => {
				await this.watchPlayEvent();
			}, 3000);
		}
	}

	setPIPValue(value:any) {
		if (this.isLoadingWavesurfer) {
			this.snackbar.open("Please wait while the audio loads...", "OK", {
				duration: 2000
			});
			return;
		}

		this.likesService.setPIPValue(value);
		if (value === 'close') {
			this.wavesurfer?.pause();
			this.isPlaying = false;
			this.likesService.playValueSubject.next(this.isPlaying);
		} else {
			this.likesService.currentTimeValue.next(this.wavesurfer?.getCurrentTime());
			localStorage.setItem("playingStateMax", String(this.isPlaying));
			setTimeout(() => {
				localStorage.removeItem("playingStateMax");
			}, 3000);

			this.wavesurfer?.pause();
		}
	}

	onPlayPause(): void {
		if (!this.isLoadingWavesurfer) {
			if (this.wavesurfer) {
				if (this.isPlaying) {
					this.wavesurfer.pause();
				} else {
					this.wavesurfer.play();
				}
			}
		} else {
			this.snackbar.open("Loading podcast audio...", "OK", {
				duration: 3000
			});
		}
	}

	toggleMute() {
		if (this.wavesurfer) {
			this.isMuted = !this.isMuted; // Toggle the mute state

			if (this.isMuted) {
				this.wavesurfer.setMuted(true);
			} else {
				this.wavesurfer.setMuted(false);
			}
		}
	}

	changeVolume(volume: number) {
		const normalizedVolume = volume / 100;
		if (this.wavesurfer) {
			this.wavesurfer.setVolume(normalizedVolume);
		}
	}

	async toggleIsLiked() {
		this.isLiked = !this.isLiked;
		const entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;

		const data = {
			entityType: "podcast",
			userId: this.userId,
			userName: "",
			emotionType: "like",
			entityId,
			createdAt: new Date()
		};

		if (this.isLiked) {
			this.likeDocId = await this.likesService.addLike(data, "");
		} else {
			await this.likesService.removeLike(this.likeDocId);
			this.likeDocId = "";
		}
	}

	skipBackwardFn() {
		if (this.wavesurfer) {
		  const currentTime = this.wavesurfer.getCurrentTime();
		  const newTime = Math.max(0, currentTime - 10);
		  this.wavesurfer.seekTo(newTime / this.durationTime);
		}
	  }

	skipForwardFn() {
		if (this.wavesurfer) {
		  const currentTime = this.wavesurfer.getCurrentTime();
		  const newTime = Math.min(this.durationTime, currentTime + 10);
		  this.wavesurfer.seekTo(newTime / this.durationTime);
		}
	}
}
